export default {
  name: 'themeSwitcher',
  getReducer(){
    const initialState = {
      themes:[1,2,3]
    }

    return (state = initialState, { type, payload }) => {
      return state;
    }
  },

  selectThemes: (state) => {
    return state.themeSwitcher.themes;
  }
}